import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddOfferComponent } from './components/add-offer/add-offer.component';
import { ListJobOfferComponent } from './components/list-job-offer/list-job-offer.component';
import { SuggestionComponent } from './components/suggestion/suggestion.component';
import { EsnAbonneViewsOfferComponent } from './components/esn-abonne-views-offer/esn-abonne-views-offer.component';
import { DetailsOfferComponent } from './components/details-offer/details-offer.component';
import { ListecandidatureComponent } from './components/listecandidature/listecandidature.component';
import { CandidatureoffreemploiComponent } from './components/candidatureoffreemploi/candidatureoffreemploi/candidatureoffreemploi.component';
import { AddTestOfferComponent } from './components/add-test-offer/add-test-offer.component';
import { AddBaremeComponent } from './components/add-bareme/add-bareme.component';
import { AddTestWegestuComponent } from './components/add-test-wegestu/add-test-wegestu.component';
import { DossierCandidatureComponent } from './dossier-candidature/dossier-candidature.component';
import { SubscriptionHasFeatureGuard } from 'app/guards/subscription-has-feature.guard';
import { EditOffreComponent } from './components/edit-offre/edit-offre.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'liste-offres-emploi',
    pathMatch: 'full',
  },
  {
    path:'liste-offres-emploi',
    component:ListJobOfferComponent,
  },
  {
    path:'ajout-offre-emploi',
    component:AddOfferComponent,
  },
   {
    path:'edit-offre-emploi/:id',
    component:EditOffreComponent,
  },
  {
    path:'suggestion-offre-emploi/:id',
    component:SuggestionComponent,
    canActivate: [SubscriptionHasFeatureGuard],
    data: { featureName: 'Matching' },
  },
  {
    path:'views-offer/:id',
    component:EsnAbonneViewsOfferComponent
  },
  {
    path:'details-offer/:id',
    component:DetailsOfferComponent
  },
  {
    path:'listcandidature/:id',
    component:ListecandidatureComponent
  },
  {
    path:'candidature',
    component:CandidatureoffreemploiComponent
  },
  {
    path:'add-test',
    component:AddTestOfferComponent
  },
  {
    path:'add-bareme',
    component:AddBaremeComponent,
    canActivate: [SubscriptionHasFeatureGuard],
    data: { featureName: 'Barème' },
  },
  {
    path:'add-test-wegestu',
    component:AddTestWegestuComponent
  },
  {
    path:'dossier-candidature/:id/:user_id',
    component:DossierCandidatureComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobOfferRoutingModule { }
